import M2hLayout from "./M2hLayout";
import M2hAuthenticatedLayout from "@/layouts/M2hAuthenticatedLayout.vue";

const LayoutsPlugin = {
  install(Vue) {
    Vue.component(M2hLayout.name, M2hLayout)
    Vue.component(M2hAuthenticatedLayout.name, M2hAuthenticatedLayout)
  }
};

export { LayoutsPlugin }
